import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Table from '../components/table-payout-matrix/main';

import { selectors as rootSelectors } from '../../root';
import Switch from '../components/other/switch';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content payout-requests">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<Switch {...props}/>
					</div>
				</div>

				<div className="container__content-body">

					<div className="ui-control-bar">
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>
									<span>{props.intl('Apply')}</span>
								</button>
							</div>
						</div>
					</div>
					<Table {...props} />
				</div>
			</div>
		</Animate>
	),
	['payout_requests_review', 'payout_requests_view_matrix_and_history']
);

export default connect(
	state => ({
		data: selectors.getData(state),
		highlightedCountryId: selectors.getHighlightedCountryId(state),
		table: selectors.getTable(state),
		can: selectors.getCan(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/payout-matrix/main.js